import { Button } from '@mui/material';
import React, { useState,useRef } from 'react';
import './Contact.css'
import confetti from 'canvas-confetti';
import emailjs from "emailjs-com";
const Contact = () => {
  const form = useRef();
    const [popup,setpopup] = useState(false);
    const[input,setinput] = useState('');
    const[emai,setemai] = useState('');
    const[mes,setmes] = useState('');
const popup1=(e)=>{
        e.preventDefault();
        emailjs.sendForm('service_zyj3l3p','template_wpzukrj',form.current,'gliHhFLccZJYp1rxE')
        .then(
          (result)=>{
            console.log(result.text)
          },
          (error)=>{
            console.log(error.text);
          }
        )
        setemai('')
        setinput('')
        setmes('')
        setpopup(true);
        Fire()
    }
    const fire = (ratio,opt) =>{
        confetti(Object.assign({},opt,{
          origin:{y:0.5},
          particleCount:Math.floor(200*ratio)
        }));
      }
    
      const Fire = () =>{
            fire(.25,{
              spread:30,
              startVelocity:60
    
            });
            fire(.2,{spread:60});
            fire(.35,{spread:100,
            decay:.9,
          scalar:1});
          fire(.1,{
            spread:130,
            startVelocity:30,
            decay:.92,
            scalar:1.2
          });
          fire(.2,{
            spread:120,
            startVelocity:45
          })
      }
    return (
        <div className='Contact' id='Contact'>
            <h1>Get In Touch</h1>
            <p>Contact Me</p>
            <div className='cform'>
                <div className='leftsection'>
                    <h4>Talk to me</h4>
                   
                    <div className='mailsec'>
                    <i class='bx bxl-gmail bmail'></i>
                    <p>Email</p>
                    <p>rammathala@gmail.com</p>
                    <span className='writeme'>
                    <a href="mailto:rammathala@gmail.com">Send Email</a>
                    <i className='uil uil-arrow-right rightarow'></i>
                    </span>
                    </div>
                    <div className='mailsec'>
                    <i class='bx bxl-linkedin ldin bmail'></i>
                    <p>Linkedin</p>
                    <span className='writeme'>
                    <a href='https://www.linkedin.com/in/ram-mathala/' target={'_blank'}>Text Me</a>
                    <i className='uil uil-arrow-right rightarow'></i>
                    </span>
                    </div>
                </div>
                <div className='rightsection'>
                    <form ref={form} onSubmit={popup1} >
                      <h3>Send Me Your Message</h3>
                      <div className='layer1'>
                        <h5>Name</h5>
                       <input className='inp'type={'text'} value={input}
                       onChange={(e)=>setinput(e.target.value)} required name='Name'></input> 
                      </div>
                      <div className='layer2'>
                            <h5>Email</h5>
                       <input name='E-mail'  value={emai} onChange={(e)=>setemai(e.target.value)}required className='inp' type={'email'}></input>
                      </div>
                      <div>
                      <h5>Message</h5>
                        <textarea name='Message' value={mes} onChange={(e)=>setmes(e.target.value)} required className='tar'></textarea>
                      </div>
                        <Button type='submit'
                        className='sbuto'>submit <i class='bx bxs-send senb'></i></Button>
                        </form>
                        { popup && (<div className='pop'>
                            <div className={'pop_container'}>
                            <i class='bx bxs-check-circle circle'></i>
                                <div>
                                    <h2>Submitted Successfully!</h2>
                                    <p>Thank You for your response.</p>
                                    <Button className='cancelb' variant="contained" onClick={()=>{setpopup(false)}}>Close</Button>
                                </div>
                            </div>
                        </div>)}
                </div>
            </div>
        </div>     
    );
};

export default Contact;
